// extracted by mini-css-extract-plugin
export var content = "_mg-1";
export var fullScreen = "_mg-0";